import { Alert } from '@vnetwork/datacentral-ui/feedback'
import { Button } from '@vnetwork/datacentral-ui/primitives'
import { useTranslation } from 'react-i18next'

interface ErrorLike {
    message?: string
    response?: { data?: { message?: string } }
}

export interface AlertErrorProps {
    error?: ErrorLike | null
    /** Show a reload button. */
    reloadButton?: boolean
    className?: string
}

/** Danger `Alert` for an API / runtime error (server message first). */
export function AlertError({
    error,
    reloadButton,
    className,
}: AlertErrorProps) {
    const { t } = useTranslation()
    const message =
        error?.response?.data?.message ??
        error?.message ??
        t('something-went-wrong')
    return (
        <Alert
            tone="danger"
            className={className}
            actions={
                reloadButton ? (
                    <Button
                        size="sm"
                        variant="secondary"
                        onClick={() => window.location.reload()}
                    >
                        {t('reload')}
                    </Button>
                ) : undefined
            }
        >
            {message}
        </Alert>
    )
}
